import { render, staticRenderFns } from "./case-list.vue?vue&type=template&id=69125652"
import script from "./case-list.vue?vue&type=script&lang=js"
export * from "./case-list.vue?vue&type=script&lang=js"
import style0 from "./case-list.vue?vue&type=style&index=0&id=69125652&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports